import { Material } from "@app/strain/materials/models/material.model";

export class SampleBoardMaterialRecipeItem {
    id?: number;
    quantity: number;
    material: Material;
    code: string;

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.quantity = entry?.quantity;
        this.material = entry?.material ? new Material(entry.material) : null;
        this.code = entry?.code ? entry.code : null;
    }
}
